import { render, staticRenderFns } from "./RPIndexOther.vue?vue&type=template&id=a42d2748"
import script from "./RPIndexOther.vue?vue&type=script&lang=js"
export * from "./RPIndexOther.vue?vue&type=script&lang=js"
import style0 from "./RPIndexOther.vue?vue&type=style&index=0&id=a42d2748&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports